declare global {
  interface Window {
    __search_modal_open?: boolean;
  }
}

export default function getSearchModalCurrentState(): boolean {
  if (typeof window !== "object") {
    console.warn(
      "[Search-ui] Calling search modal state on a server function, return default false...",
    );
    return false;
  }

  return !!window.__search_modal_open;
}
